module.exports = __webpack_public_path__ + "assets/TPerpBisectorDetailed.e957c231de663d9909e45910c294b423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TPerpBisectorDetailed.png
// module id = 582
// module chunks = 0